class Resource {
  type;

  content;

  updateFromJson(json) {
    this.type = json.type;
    this.content = json.content;
  }
}

export default Resource;
